var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-footer text-right"},[_c('img',{attrs:{"src":"https://www.wrraptheme.com/demo/payangel/img/Powered_by_StandApp.559e4fb5.svg","width":"180","alt":""}})])
}]

export { render, staticRenderFns }